import * as React from 'react';

import { ISingleLinkProps } from '../types';

import { CopyButton, Icons, Tooltip } from 'src/components';
import { TargetCheck } from './TargetCheck/TargetCheck';

export const SingleLink: React.FC<ISingleLinkProps> = ({
  link,
  isLoading,
  onRun,
}) => {
  return (
    <div className={`bg-grey px-4 rounded mb-10 ${isLoading ? 'loader' : ''}`}>
      <div className="flex items-center justify-between text-center py-3">
        <p>{link.createdOn || 'Not run yet'}</p>
        <div className="flex-1">
          {link.status === 'Success' ? (
            <Icons.Success className="mr-2" />
          ) : (
            <Icons.Warning className="mr-2" />
          )}
          {link.displayMessage}
        </div>
        <div>
          <code className="align-middle font-mono text-base mr-4 inline-block w-32 text-overflow-ellipsis">
            {link.uniqueLinkId}
          </code>
          <Tooltip text="Copy ID">
            <CopyButton
              toCopy={link.uniqueLinkId}
              successMessage="Link ID copied"
            />
          </Tooltip>
        </div>
      </div>
      <div className="pt-2 pb-4">
        <p className="bg-grey-light break-all mb-1 py-2 px-3">{link.url}</p>
        {link.redirects &&
          link.redirects.map((redirect, index) => (
            <p
              className="relative bg-grey-light break-all mb-1 py-2 pr-3 pl-8"
              key={index}
            >
              <span className="text-xl font-bold absolute pin-t pin-l ml-3">
                ↳
              </span>{' '}
              {redirect.redirectUrl}
            </p>
          ))}
      </div>
      <div className="flex justify-center pb-4">
        <TargetCheck link={link} onRun={onRun} />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/TargetCheck/components/SingleLink.tsx